export const EXPENSE_SCHEDULE_EXPORT_TYPES = {
  MONTHLY: "MONTHLY",
  LINE_ITEMS: "LINE_ITEMS",
  VENDORS: "VENDORS",
};

export type EXPENSE_SCHEDULE_EXPORT_TYPES_TYPE =
  keyof typeof EXPENSE_SCHEDULE_EXPORT_TYPES;

export const EXPENSE_SCHEDULE_EXPORT_TYPES_DISPLAY = {
  [EXPENSE_SCHEDULE_EXPORT_TYPES.MONTHLY]: "Months",
  [EXPENSE_SCHEDULE_EXPORT_TYPES.LINE_ITEMS]: "Bill Items",
  [EXPENSE_SCHEDULE_EXPORT_TYPES.VENDORS]: "Vendors",
};
